module.exports = __webpack_public_path__ + "static/media/mirror.2f7fcfe3.png";